import {getApi} from './../core/index';

export function decodeQrCode(language, params) {
    return getApi(
        language,
        params,
        '/restaurant/ordina-tavolo/qr-code/decode',
    );
}
